import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useMcMembers } from '@/hooks/useMcMembers';

export type McViewerRole = 'owner' | 'member';

/**
 * Rolle des angemeldeten Nutzers in der gewaehlten Merchant Center, abgeleitet
 * aus der Mitgliederliste (Zeile mit `user_id === user.id`). `role` ist `null`,
 * wenn keine MC gewaehlt ist, kein Nutzer angemeldet ist, die Liste scheitert
 * oder keine Zeile zum Nutzer passt. Aufrufer behandeln `null` wie "Rolle
 * unbekannt" und blenden nichts aus, was ein Eigentuemer sehen darf.
 */
export function useMcViewerRole(mcId: string | null): { role: McViewerRole | null; isLoading: boolean } {
  const { user } = useAuth();
  const { members, isLoading } = useMcMembers(mcId);
  const userId = user?.id;
  const role = useMemo<McViewerRole | null>(() => {
    if (!mcId || !userId) return null;
    return members.find((m) => m.user_id === userId)?.role ?? null;
  }, [mcId, userId, members]);
  return { role, isLoading: isLoading && !!mcId };
}
